import { JourneyDetails, LocationDetails } from "./RouteContext";

const encodeLocation = (loc: LocationDetails): string => {
  const [lng, lat] = loc.coordinates;
  return `${loc.text},${lng},${lat}`;
};

const decodeLocation = (raw: string): LocationDetails | null => {
  const value = decodeURIComponent(raw);
  const parts = value.split(",");
  if (parts.length < 3) return null;
  const lat = Number(parts[parts.length - 1]);
  const lng = Number(parts[parts.length - 2]);
  const text = parts.slice(0, -2).join(",").trim();
  if (!text || !Number.isFinite(lng) || !Number.isFinite(lat)) return null;
  return {
    coordinates: [lng, lat],
    text,
    placeName: text,
  };
};

export const parseJourneyFromUrl = (): JourneyDetails | null => {
  if (typeof window === "undefined") return null;
  const params = new URLSearchParams(window.location.search);
  const vanRaw = params.get("van");
  const naarRaw = params.get("naar");
  const from = vanRaw ? decodeLocation(vanRaw) : null;
  const to = naarRaw ? decodeLocation(naarRaw) : null;
  if (!from && !to) return null;
  return {
    from: from ?? undefined,
    to: to ?? undefined,
  };
};

export const syncJourneyToUrl = (journey: JourneyDetails | null) => {
  if (typeof window === "undefined") return;
  const params = new URLSearchParams(window.location.search);
  if (journey?.from) {
    params.set("van", encodeLocation(journey.from));
  } else {
    params.delete("van");
  }
  if (journey?.to) {
    params.set("naar", encodeLocation(journey.to));
  } else {
    params.delete("naar");
  }
  const query = params.toString();
  const base = `${window.location.pathname}${window.location.hash}`;
  const next = query ? `${window.location.pathname}?${query}${window.location.hash}` : base;
  window.history.replaceState(null, "", next);
};
